import { Package, MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "../lib/constants";

export default function Hero({ onQuoteClick }) {
  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-12 pb-16 lg:pt-16 lg:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-8 items-center">
          {/* Text */}
          <div className="order-2 lg:order-1">
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-black uppercase tracking-tight leading-[0.95]">
              <span className="text-[#0B1F4D]">Enviamos tus envíos</span>
              <br />
              <span className="text-[#D61F26]">a República Dominicana</span>
            </h1>
            <p className="mt-6 text-base sm:text-lg lg:text-xl text-gray-600 leading-relaxed max-w-xl">
              Cajas, tanques, paquetes y electrodomésticos con seguridad, rapidez
              y confianza. Servicio confiable desde Nueva York hacia toda la
              República Dominicana.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <button
                data-testid="hero-cotiza-btn"
                onClick={onQuoteClick}
                className="inline-flex items-center justify-center gap-2 bg-[#D61F26] text-white px-7 py-4 uppercase font-bold tracking-wider hover:bg-[#A3161C] transition-all text-sm shadow-md"
              >
                <Package className="w-5 h-5" strokeWidth={2.5} />
                Cotiza Tu Envío
              </button>
              <a
                data-testid="hero-whatsapp-btn"
                href={buildWhatsAppLink("Hola San José Shipping, me gustaría más información sobre sus servicios de envío.")}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#0B1F4D] text-white px-7 py-4 uppercase font-bold tracking-wider hover:bg-[#091840] transition-all text-sm shadow-md"
              >
                <MessageCircle className="w-5 h-5" strokeWidth={2.5} />
                Habla por WhatsApp
              </a>
            </div>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2 relative">
            <img
              src="/hero-composite.png"
              alt="Envíos a República Dominicana - barco, electrodomésticos, tanques y cajas"
              className="w-full h-auto object-contain max-h-[640px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
